import { CommonModule } from '@angular/common';
import { Directive, ElementRef, forwardRef, Input, NgModule, OnDestroy } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator } from '@angular/forms';
import { Destroyable } from '@uw/core/destroyable';
import { fromEvent, Subscription, map, takeUntil } from 'rxjs';

@Directive({
    selector: '[uwPostalZipInput]',
    host: {
        'class': 'uw-postal-zip-input'
    },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PostalZipInputDirective),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PostalZipInputDirective),
            multi: true
        }
    ]
})
export class PostalZipInputDirective extends Destroyable implements ControlValueAccessor, Validator, OnDestroy {

  @Input() countryFormControlName: string = "country";

  constructor(
    private readonly _elementRef: ElementRef<HTMLInputElement>
  ) {
    super();
  }

  validate(control: AbstractControl): ValidationErrors {
    const countryControl = control.parent?.get(this.countryFormControlName);

    if (!this.registerOnValidatorChangeSubscription && countryControl) {
      this.registerOnValidatorChangeSubscription = countryControl
        .valueChanges
        .pipe(
          takeUntil(this._destroyed$),
        )
        .subscribe(this.registerOnValidatorFn);
    }

    const postalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

    const zipCodeRegEx = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

    const regEx = countryControl?.value == "US" ? zipCodeRegEx : postalCodeRegex;

    if (!regEx.test(control.value) && countryControl?.value) {
      return {
        postalZip: true
      };
    }

    return null as unknown as ValidationErrors;
  }

  registerOnValidatorChange?(fn: () => void): void { this.registerOnValidatorFn = fn; }

  registerOnValidatorFn!: () => void;

  registerOnValidatorChangeSubscription!: Subscription;

  writeValue(obj: any): void {
    this._elementRef.nativeElement.value = obj;
  }

  registerOnChange(fn: any): void {
    fromEvent(this._elementRef.nativeElement, "keyup")
      .pipe(
        takeUntil(this._destroyed$),
        map(_ => this._elementRef.nativeElement.value)
      )
      .subscribe(fn);
  }

  registerOnTouched(fn: any): void { }

  setDisabledState?(isDisabled: boolean): void { }
}


@NgModule({
    exports: [PostalZipInputDirective],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        PostalZipInputDirective
    ]
})
export class PostalZipInputModule { }
